export type ProjectItem = {
    title: string;
    description: string;
    technologies: string[];
};

export type ProjectsMock = {
    title: string;
    subtitle: string;
    projects: ProjectItem[];
    viewLabel: string;
    githubAriaLabel: string;
};

export const projectsMock: ProjectsMock = {
    title: 'Projects',
    subtitle: "Exploring the boundaries of what's possible in digital space",
    projects: [
        {
            title: 'Neural Interface',
            description: 'AI-powered communication platform with real-time translation',
            technologies: ['React', 'TensorFlow', 'WebRTC', 'Node.js'],
        },
        {
            title: 'Quantum Dashboard',
            description: 'Advanced data visualization for complex systems',
            technologies: ['Three.js', 'D3.js', 'React', 'WebGL'],
        },
        {
            title: 'Holographic UI Kit',
            description: 'Next-gen component library with 3D interactions',
            technologies: ['TypeScript', 'Framer Motion', 'Tailwind'],
        },
        {
            title: 'Nexus Platform',
            description: 'Decentralized social network with blockchain integration',
            technologies: ['Web3', 'Solidity', 'React', 'IPFS'],
        },
        {
            title: 'AR Commerce',
            description: 'Augmented reality shopping experience',
            technologies: ['AR.js', 'Three.js', 'React', 'WebXR'],
        },
        {
            title: 'Synth Studio',
            description: 'Web-based music production and collaboration tool',
            technologies: ['Web Audio API', 'React', 'WebSocket'],
        },
    ],
    viewLabel: 'View',
    githubAriaLabel: 'GitHub',
};
